import React, { useEffect, useRef } from 'react';

const intersectingOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1
};

const ScrollIntersecting = ({ fetchFn, children, hasMore, reversed = false, error, clearErrorFn, isReadyForScroll }) => {
    const sentinelRef = useRef(null);
    const intersect = (entries) => {
        const sentinel = entries[0];
        if (!sentinel.isIntersecting && !!error) {
            clearErrorFn();
        }
        if (!sentinel.isIntersecting || !hasMore) {
            return;
        }

        if (isReadyForScroll) {
            fetchFn();
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(intersect, intersectingOptions);
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
        return () => {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [intersect]);

    return (
        <>
            {children}
            <div ref={sentinelRef} style={{ width: 100, height: 100, margin: 16, ...(reversed && { order: -1 }) }}></div>
        </>
    );
};

export default ScrollIntersecting;
